
import Vue from 'vue'
import { Checkbox, TextDisplay } from '@/components/formGroups'
import { SchoolTeacherDto } from '@ViewModels/SchoolTeacherDto'

export default Vue.extend({
   name: 'TeacherDetailsForm',
   props: {
      schoolId: String,
      editingItem: Object as () => SchoolTeacherDto,
   },
   data() {
      return {
         classroomOptions: [] as NameValuePair[],
         schoolteacherOptions: [] as NameValuePair[],
      }
   },
   computed: {
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
      userIsSchoolAdmin(): boolean {
         return this.$store.getters.userIsSchoolAdmin
      },
   },
   components: {
      Checkbox,
      TextDisplay,
   },
})
